import React from "react";
import { styled } from '@mui/material/styles';
import {
    formatDollar,
} from "../utilityFunctions";
import { CardContent, Paper, Table, TableBody, TableContainer, TableHead, Typography } from "@mui/material";
import { Root as BVTRoot, StyledTableCell, StyledTableRow } from './BVTStyledComponents';

const PREFIX = 'SharedSavingsTable';

const classes = {
    head: `${PREFIX}-head`,
    body: `${PREFIX}-body`,
    root: `${PREFIX}-root`,
    table: `${PREFIX}-table`,
    tableContainer: `${PREFIX}-tableContainer`,
    statusIcon: `${PREFIX}-statusIcon`,
    red: `${PREFIX}-red`,
    green: `${PREFIX}-green`,
    copyButton: `${PREFIX}-copyButton`,
    excelButton: `${PREFIX}-excelButton`
};

// Use BVT styled components for consistency
const Root = BVTRoot;

// Row styles for the Shared Savings Table Specifically 
const rowStyles = {
    subtotal: { 
        fontWeight: "bold", 
    },
    projected_final_contract_value_without_savings: {
        fontWeight: "bold",
        borderTop: "thick double gray",
    },
    revenue_back_to_owner: { 
        fontWeight: "bold", 
    },
    savings_added_to_profit: { 
        fontWeight: "bold", 
    },
    total_revised_budget_after_revenue_back_to_owner: {
        borderTop: "thick double gray",
        fontWeight: "bold",
    },
    total_gross_profit_after_savings_split: {
        fontWeight: "bold",
    },
};

// Adding Shared Savings Table as additional render -- Break out into separate component if needed
const SharedSavingsTable = ({budgetData, classes}) => {
    if (!budgetData || !budgetData?.shared_savings_data?.shared_savings) {
        return null; // Don't render the table if `shared_savings` is false or missing
    }

    const orderedKeys = [
        "general_conditions_budget",
        "estimated_gmp_costs",
        "subtotal",
        "insurance",
        "fee",
        "projected_final_contract_value_without_savings",
        //   "current_owner_contract_value",
        //   "projected_savings",
        "current_projected_gmp_settings",
        "savings_added_to_gross_profit",
        "revenue_back_to_owner2",
        "total_revised_budget_after_revenue_back_to_owner",
        "total_gross_profit_after_savings_split",
        //   "ls_profit",
        //   "savings_added_to_profit",
        "final_gross_profit_percentage"
    ];

    const keyLabels = {
        general_conditions_budget: "General Conditions Budget (Revenue)",
        estimated_gmp_costs: "Estimated GMP Costs",
        subtotal: "Subtotal",
        insurance: "Negotiated Insurance",
        fee: " Negotiated Fee",
        projected_final_contract_value_without_savings:
            "Projected Final Contract Value (Without Savings)",
        current_owner_contract_value: "Current Owner Contract Value",
        projected_savings: "Projected Savings",
        current_projected_gmp_settings: "Current Projected GMP Savings",
        savings_added_to_gross_profit: "Savings Added to Gross Profit",
        revenue_back_to_owner2: "Revenue Back to Owner",
        total_revised_budget_after_revenue_back_to_owner: "Total Revised Budget After Revenue Back to Owner",
        total_gross_profit_after_savings_split: "Total Gross Profit After Savings Split",
        ls_profit: "LS Profit",
        savings_added_to_profit: "Savings Added to Profit",
        final_gross_profit_percentage: "Final Gross Profit Percentage",
    };
    return (
        <Root style={{ marginTop: "20px" }}>
            <Typography
                variant="h6"
                className="bvt-table-title"
                sx={{ pl: 2, pt: 0 }}
            >
                Shared Savings Details
            </Typography>
            <CardContent sx={{ pt:0, mt:0 }}>
                <TableContainer component={Paper}>
                    <Table className="bvt-table" aria-label="shared-savings-table">
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell className="table-header">Category</StyledTableCell>
                                <StyledTableCell className="table-header">Value</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {orderedKeys.map((key) => {
                                const value = budgetData?.shared_savings_data[key];
                                // Only render rows for keys that exist in the data
                                if (value === undefined) return null;
                                return (
                                    <StyledTableRow
                                        key={key}
                                        className={
                                            key === "subtotal" || 
                                            key === "projected_final_contract_value_without_savings" ||
                                            key === "total_revised_budget_after_revenue_back_to_owner" || 
                                            key === "total_gross_profit_after_savings_split" ? "section-header" : ""
                                        }
                                        style={rowStyles[key] || {}}>
                                        <StyledTableCell>{keyLabels[key] || key}</StyledTableCell>
                                        <StyledTableCell
                                            style={{
                                                color: typeof value === "number" && value < 0 ? "red" : "inherit", 
                                                ...rowStyles[key],
                                            }}>
                                            {key === "final_gross_profit_percentage" ? `${(parseFloat(value) || 0).toFixed(2)}%` : formatDollar(parseFloat(value) || 0)}
                                        </StyledTableCell>
                                    </StyledTableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Root>
    );
};

export default SharedSavingsTable;